import React from 'react';
import ReactDOM from 'react-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import App from './container/app/App';
import { store } from './redux/store';
// import 'antd/dist/antd.css';
import './styles/scss/main.scss';
import './styles/css/custom-antd.css';
import 'react-toastify/dist/ReactToastify.css';

ReactDOM.render(
  <GoogleOAuthProvider clientId={process.env.REACT_APP_GG_CLIENT_ID}>
    <React.StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
      <ToastContainer autoClose={5000} />
    </React.StrictMode>
  </GoogleOAuthProvider>,
  document.getElementById('root'),
);
